/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Kind_Agri_MaterialsInputs */

const vi_stocktake_kind_agri_materials = /** @type {(inputs: Stocktake_Kind_Agri_MaterialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư nông nghiệp`)
};

/**

* @param {Stocktake_Kind_Agri_MaterialsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_kind_agri_materials = /** @type {((inputs?: Stocktake_Kind_Agri_MaterialsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Kind_Agri_MaterialsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_kind_agri_materials(inputs)
});